/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncIntegrationsListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from 'react-i18next';
import {config} from '../config';

const Integrations: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('integrations.name')}`}</title>
                <meta name="description" content="Integrations" />
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}`}
                    component={AsyncIntegrationsListComponent}
                />
                <Redirect
                    exact
                    from={`${match?.url}/`}
                    to={`${match?.url}`}
                />
            </Switch>
        </div>
    );
};

export default Integrations;
